import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";

const MAX_ITEMS = 8;

// data: array of InitiativeActivityEntity with initiativeName attached server-side
const InitiativeActivityCard = ({ data, title }) => {
    const navigate = useNavigate();
    const items = (Array.isArray(data) ? data : []).slice(0, MAX_ITEMS);

    return (
        <div className="initiative-activity-card">
            {title && (
                <header className="initiative-activity-card__header">
                    <h4>{title}</h4>
                </header>
            )}
            {items.length === 0 ? (
                <p className="initiative-activity-card__empty">No recent activity.</p>
            ) : (
                <ul className="initiative-activity-card__list">
                    {items.map((item, idx) => (
                        <li
                            key={item.id}
                            className={`initiative-activity-card__row${item.eventType === "system" ? " -system" : ""}`}
                            role="button"
                            tabIndex={0}
                            onClick={() => navigate(`/initiatives/${item.initiativeId}`)}
                            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && navigate(`/initiatives/${item.initiativeId}`)}
                        >
                            {item.initiativeName && item.initiativeName !== items[idx - 1]?.initiativeName && (
                                <div className="initiative-activity-card__initiative">{item.initiativeName}</div>
                            )}
                            <div className="initiative-activity-card__body">
                                <span className="initiative-activity-card__text">
                                    {item.eventType === "system" ? `⚙ ${item.text}` : item.text}
                                </span>
                                <span className="initiative-activity-card__date">
                                    {formatDistanceToNow(new Date(item.createdDate.endsWith("Z") ? item.createdDate : item.createdDate + "Z"), { addSuffix: true })}
                                </span>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default InitiativeActivityCard;
